import React, { memo } from 'react';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { FormCheckbox, FormInput } from '@core/components/form';
import { WidgetConfirmProps } from '../types';
import { CardTitle } from 'reactstrap';

export function defineSectiontWidgetConfirmForm() {
  return formGroup({
    pageBreak: formControl<boolean>({ label: 'Page Break', initialValue: true }),
    hideBrumpcrumb: formControl<boolean>({ label: 'Hide bottom breadcrumb', initialValue: false }),
    breadcrumb: formControl<string>({ label: 'Page Breadcrumb Label' }),
  });
}

export type SectionTitleWidgetConfigType = ReturnType<typeof defineSectiontWidgetConfirmForm>;
export type SectionTitleWidgetConfigData = FormDataType<typeof defineSectiontWidgetConfirmForm>;

export const SectionTitleWidgetConfig = memo((props: WidgetConfirmProps<SectionTitleWidgetConfigType, SectionTitleWidgetConfigData>) => {
  const { form, data } = props;
  return (
    <CBody>
      <CardTitle>Widget UI Settings</CardTitle>
      <FormCheckbox control={form.controls.pageBreak} />
      <FormCheckbox control={form.controls.hideBrumpcrumb} />
      <FormInput control={form.controls.breadcrumb} />
    </CBody>
  );
});
